import { Grid } from '@material-ui/core';
import Button from 'components/button';
import { Field, Form, Input, Textarea } from 'components/forms';
import { refundForm } from 'components/forms/decorators';
import SectionBanner from 'components/section-banner';
import SectionTitle from 'components/section-title';
import createOtherRefundOrderMutation from 'graphql/mutations/orders/create-other-multiplier-refund-order.gql';
import React, { Component } from 'react';
import styles from './styles.css';
@refundForm(createOtherRefundOrderMutation)
export default class OtherMultiplierRefundCreate extends Component {
    render() {
        return (
            <Grid container direction="column">
                <SectionBanner />
                <SectionTitle title='Otras Acciones' />
                <Form
                    fields={[
                        {key: 'estimatedAmount', required: false, initial: 0},
                        {key: 'title'},
                        {key: 'description'},
                    ]}
                    errors={this.props.errors}
                    onSubmit={this.props.onSubmit}>
                    {({getFieldProps, renderErrors, isValid}) => (
                        <Grid container spacing={2} style={{marginTop: 20}}>
                            <Field label='Título'>
                                <Input type='text' {...getFieldProps('title')} />
                                {renderErrors('title')}
                            </Field>

                            <Field label='Descripción'>
                                <Textarea {...getFieldProps('description')} />
                                {renderErrors('description')}
                            </Field>
                            {renderErrors('__all__')}
                            <Form.Actions>
                                <Button theme='yellow' disabled={!isValid() || this.props.loading}>
                                    {this.props.loading ? 'ENVIANDO...' : 'ENVIAR'}
                                </Button>
                            <p className={styles.reminder}>Recuerde seleccionar la organización correcta antes de enviar el pedido</p>
                            </Form.Actions>
                        </Grid>
                    )}
                </Form>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./views/refunds/other-multiplier/index.js